function editEmployee() {
    if (document.querySelector('.mg-employer')) {
        let parentElem = document.querySelector('.mg-add-workers')
        let employee = parentElem.querySelectorAll('.mg-table__body')

        document.querySelectorAll('[data-bd]').forEach(el => el.setAttribute('data-bd', el.textContent))

        // Кнопки в preview popup
        let previewEmployee = document.querySelector('.popup-information--info-org-eight')
        let delBtn = previewEmployee.querySelector('[href="#popup-delete-employee"]')
        let editbutton = previewEmployee.querySelector('[href="#popup-edit-employee"]')

        let delEmployee = parentElem.querySelector('.mg-table__body-container')

        // Переменные для внешних событий
        let editBtn = parentElem.querySelectorAll('[data-edit]')
        let removeBtn = parentElem.querySelectorAll('[data-remove]')


        // Переменные для внутренних событий
        editbutton.onclick = editFromPreview(previewEmployee)
        delBtn.onclick = removeFromPreview(previewEmployee, employee, delEmployee)
        employee.forEach(empl => empl.onclick = popupBuild(empl))
        editBtn.forEach((btn, id) => btn.onclick = editEm(employee[id]))
        removeBtn.forEach((btn, id) => btn.onclick = removeEm(employee[id], delEmployee))
    }
}

const editEm = empl => {
    return (e) => {
        // Полученные значения
        let storageDate
        let popup = document.querySelector('.popup-edit-employee')
        // let name = empl.querySelector('[data-name]').textContent.split(' ')
        let name = empl.querySelector('[data-name]').textContent
        let phone = empl.querySelector('[data-phone]').textContent
        // let role = empl.querySelector('[data-role]').textContent
        let sub = empl.querySelector('[data-sub]').textContent
        let mail = empl.querySelector('[data-mail]').getAttribute('value')
        // let db = empl.querySelector('[data-db]').getAttribute('value').split('.')
        let db = empl.querySelector('[data-db]').getAttribute('value')
        let subord = empl.querySelector('[data-subord]').getAttribute('value')

        storageDate = empl.querySelector('[data-db]').getAttribute('value')
        // Редактируемые поля
        // popup.querySelector('[name="sur"]').value = name[0]
        // popup.querySelector('[name="first"]').value = name[1]
        // popup.querySelector('[name="middle"]').value = name[2]
        popup.querySelector('[name="name"]').value = name
        popup.querySelector('[name="phone"]').value = phone
        popup.querySelector('[name="email"]').value = mail
        // popup.querySelector('[name="day"]').value = db[0]
        // popup.querySelector('[name="month"]').value = db[1]
        // popup.querySelector('[name="year"]').value = db[2]
        popup.querySelector('[name="birthday"]').value = db
        popup.querySelector('[data-subord]').querySelectorAll('.dropdown__list-item-text').forEach(el => {
            el.closest('li').classList.remove('dropdown__list-item--active')

            if (el.textContent === subord) {
                console.log(el.textContent)
                el.closest('li').classList.add('dropdown__list-item--active')
                el.textContent = subord
            }
        })
        popup.querySelector('[data-subord]').querySelector('.dropdown__button-text').textContent = subord

        popup.setAttribute('data-id', empl.querySelector('[data-id]').textContent)

        popup.querySelector('[name="birthday"]').onfocus = () => {
            popup.querySelector('[name="birthday"]').setAttribute('type', 'date')
            db = db.split('.')
            db = [...db].reverse()
            popup.querySelector('[name="birthday"]').value = `${db[0]}-${db[1]}-${db[2]}`
            popup.querySelector('[name="birthday"]').oninput = () => {
                let arr = popup.querySelector('[name="birthday"]').value
                arr = arr.split('-')
                if (parseInt(arr[0]) > 2030) {
                    arr[0] = new Date().getFullYear()
                    popup.querySelector('[name="birthday"]').value = `${arr[0]}-${arr[1]}-${arr[2]}`
                }
            }
        }

        // popup.querySelector('[data-role]').querySelectorAll('.dropdown__list-item-text').forEach(el => {
        //     if (el.textContent === popup.querySelector('[data-role]').querySelector('.dropdown__button-text').textContent) {
        //         el.textContent = role
        //     }
        // })
        // popup.querySelector('[data-role]').querySelector('.dropdown__button-text').textContent = role

        popup.querySelector('[data-sub]').querySelectorAll('.dropdown__list-item-text').forEach(el => {
            if (el.textContent === popup.querySelector('[data-sub]').querySelector('.dropdown__button-text').textContent) {
                el.textContent = sub
            }
        })
        popup.querySelector('[data-sub]').querySelector('.dropdown__button-text').textContent = sub
    }
}
const formFieldComp = form => {
    if (form) {
        let inputs = form.querySelectorAll('.Input__inp')

        inputs.forEach(inp => {
            inp.oninput = () => {
                if (inp.value) {
                    inp.classList.add('Input--valid')
                    inp.classList.remove('Input--invalid')
                } else {
                    inp.classList.remove('Input--valid')
                    inp.classList.add('Input--invalid')
                }
            }
            if (inp.value != -1) {
                inp.classList.add('Input--valid')
                inp.classList.remove('Input--invalid')
            } else {
                inp.classList.remove('Input--valid')
                inp.classList.add('Input--invalid')
            }
        })

        let roleDrop = form.querySelector('.dropdown--role')
        let roleSelect = roleDrop.querySelectorAll('.dropdown__list-item')
        let showDes = roleDrop.querySelector('.Privacy-policy')
        let parLabel = roleDrop.querySelector('label')

        parLabel.onmousedown = e => {
            parLabel.toggleAttribute('checked')
        }

        roleSelect.forEach(el => {
            el.setAttribute('data-val', el.querySelector('span').textContent)
            el.onclick = () => {
                if (el.getAttribute('data-val') === showDes.getAttribute('data-show')) {
                    showDes.removeAttribute('style')
                } else {
                    showDes.style.display = "none"
                }
            }
        })
    }
}

formFieldComp(document.querySelector('.popup-edit-employee'))


const editEmployeeApi = form => {
    let inputs = form.querySelectorAll('.Input--valid')
    let selectors = form.querySelectorAll('.dropdown__button--valid')
    let roleDrop = form.querySelector('.dropdown--role')
    let showDes = roleDrop.querySelector('.Privacy-policy')
    let parLabel = roleDrop.querySelector('label')
    let successMsg = form.querySelector('[data-status-success]')
    let errorMsg = form.querySelector('[data-status-error]')
    // let name = inputs[0].value + ' ' + inputs[1].value + ' ' + inputs[2].value
    // let dateB = inputs[3].value + '.' + inputs[4].value + '.' + inputs[5].value
    let name = inputs[0].value
    let dateB = inputs[1].value

    let body

    if (selectors[0].querySelector('.dropdown__button-text').textContent === showDes.getAttribute('data-show')) {
        let isChecked
        parLabel.hasAttribute('checked') ? isChecked = 'Y' : isChecked = 'N'
        body = {
            title: 'Edit employee',
            id: document.querySelector('#popup-edit-employee').getAttribute('data-id'),
            name: name,
            dateBir: dateB,
            // mail: inputs[6].value,
            // phone: inputs[7].value,
            mail: inputs[2].value,
            phone: inputs[3].value,
            role: selectors[0].querySelector('.dropdown__button-text').textContent,
            showOrders: isChecked,
            jobTitle: selectors[1].querySelector('.dropdown__button-text').textContent,
            subordination: selectors[2].querySelector('.dropdown__button-text').textContent
        }
    } else {
        body = {
            title: 'Edit employee',
            id: document.querySelector('#popup-edit-employee').getAttribute('data-id'),
            name: name,
            dateBir: dateB,
            // mail: inputs[6].value,
            // phone: inputs[7].value,
            mail: inputs[2].value,
            phone: inputs[3].value,
            role: selectors[0].querySelector('.dropdown__button-text').textContent,
            jobTitle: selectors[1].querySelector('.dropdown__button-text').textContent,
            subordination: selectors[2].querySelector('.dropdown__button-text').textContent
        }
    }

    $.ajax({
        // url: 'https://jsonplaceholder.typicode.com/posts',
        url: form.getAttribute('data-action'),
        method: 'post',
        dataType: 'json',
        data: body,
        success: response => {
            if (response.status === 'success') {
                errorMsg.style.display = 'none'
                successMsg.removeAttribute('style')
                elementUpdate('#employers');
                // elementUpdate('#employersedit');
            } else {
                successMsg.style.display = 'none'
                errorMsg.removeAttribute('style')
            }
        },
        error: response => {
            successMsg.style.display = 'none'
            errorMsg.removeAttribute('style')
        }
    })
}

const removeEm = (empl, pe) => {
    // Реализация удаления сотрудника
    return (e) => {
        let parentPopup = document.querySelector('.popup-delete-employee')
        let txtMsg = parentPopup.querySelector('.popup-delete-employee__text-msg')
        let yBtn = parentPopup.querySelector('[data-type-y]')
        let nBtn = parentPopup.querySelector('[data-type-n]')

        txtMsg.setAttribute('style', 'display: none;')

        yBtn.onclick = () => {
            $.ajax({
                // url: 'https://jsonplaceholder.typicode.com/posts',
                url: parentPopup.getAttribute('data-action'),
                method: 'post',
                dataType: 'json',
                data: { formTitle: 'Delete Employee', id: empl.querySelector('[data-id]').textContent },
                success: response => {
                    if (response.status === 'success') {
                        txtMsg.removeAttribute('style')
                        txtMsg.classList.add('success-msg')
                        txtMsg.classList.remove('error-msg')
                        pe.removeChild(empl)
                        txtMsg.textContent = 'Сотрудник удален!'
                        elementUpdate('#employers');
                        // elementUpdate('#employersedit');
                        setTimeout(() => {
                            $.fancybox.close();
                        }, 2000)
                    } else {
                        txtMsg.removeAttribute('style')
                        txtMsg.classList.remove('success-msg')
                        txtMsg.classList.add('error-msg')
                        txtMsg.textContent = 'Произошла ошибка при удалении сотрудника'
                    }
                },
                error: response => {
                    txtMsg.removeAttribute('style')
                    txtMsg.classList.remove('success-msg')
                    txtMsg.classList.add('error-msg')
                    txtMsg.textContent = 'Произошла ошибка при удалении сотрудника'
                }
            })
        }

        nBtn.onclick = () => {
            $.fancybox.close();
        }
    }
}

const popupBuild = empl => {
    return e => {
        e.stopPropagation()
        // Заполнение этого попапа
        let popup = document.querySelector('.popup-information--info-org-eight')

        popup.setAttribute('data-id', empl.querySelector('[data-id]').textContent)
        popup.querySelector('[data-name]').textContent = empl.querySelector('[data-name]').textContent
        popup.querySelector('[data-sub]').textContent = empl.querySelector('[data-sub]').textContent
        popup.querySelector('[data-phone]').textContent = empl.querySelector('[data-phone]').textContent
        popup.querySelector('[data-role]').textContent = empl.querySelector('[data-role]').textContent
        popup.querySelector('[data-mail]').textContent = empl.querySelector('[data-mail]').getAttribute('value')
        popup.querySelector('[data-bd]').textContent = empl.querySelector('[data-db]').getAttribute('value')
        popup.querySelector('[data-subord]').textContent = empl.querySelector('[data-subord]').getAttribute('value')
    }
}

const removeFromPreview = (preview, empl, emplParent) => {
    return e => {
        if (empl !== -1) {
            empl.forEach(em => {
                if (em.querySelector('[data-id]').textContent === preview.getAttribute('data-id')) {
                    let parentPopup = document.querySelector('.popup-delete-employee')
                    let txtMsg = parentPopup.querySelector('.popup-delete-employee__text-msg')
                    let yBtn = parentPopup.querySelector('[data-type-y]')
                    let nBtn = parentPopup.querySelector('[data-type-n]')

                    txtMsg.setAttribute('style', 'display: none;')

                    yBtn.onclick = () => {
                        $.ajax({
                            // url: 'https://jsonplaceholder.typicode.com/posts',
                            url: parentPopup.getAttribute('data-action'),
                            method: 'post',
                            dataType: 'json',
                            data: { formTitle: 'Delete Employee', id: em.querySelector('[data-id]').textContent },
                            success: response => {
                                if (response.status === 'success') {
                                    txtMsg.removeAttribute('style')
                                    txtMsg.classList.add('success-msg')
                                    txtMsg.classList.remove('error-msg')
                                    emplParent.removeChild(em)
                                    txtMsg.textContent = 'Сотрудник удален!'
                                    elementUpdate('#employers');
                                    // elementUpdate('#employersedit');
                                    setTimeout(() => {
                                        $.fancybox.close();
                                    }, 2000)
                                } else {
                                    txtMsg.removeAttribute('style')
                                    txtMsg.classList.remove('success-msg')
                                    txtMsg.classList.add('error-msg')
                                    txtMsg.textContent = 'Произошла ошибка при удалении сотрудника'
                                }
                            },
                            error: response => {
                                txtMsg.removeAttribute('style')
                                txtMsg.classList.remove('success-msg')
                                txtMsg.classList.add('error-msg')
                                txtMsg.textContent = 'Произошла ошибка при удалении сотрудника'
                            }
                        })
                    }
                    nBtn.onclick = () => {
                        $.fancybox.close();
                    }
                }
            })
        }
    }
}

const editFromPreview = dPopup => {
    return e => {
        e.stopPropagation()
        // Полученные значения
        let storageDate
        let popup = document.querySelector('.popup-edit-employee')
        popup.setAttribute('data-id', dPopup.getAttribute('data-id'))
        // let name = dPopup.querySelector('[data-name]').textContent.split(' ')
        let name = dPopup.querySelector('[data-name]').textContent
        // let bd = dPopup.querySelector('[data-bd]').getAttribute('data-bd').split('.')
        let bd = dPopup.querySelector('[data-bd]').textContent
        let phone = dPopup.querySelector('[data-phone]').textContent
        let mail = dPopup.querySelector('[data-mail]').textContent
        let role = dPopup.querySelector('[data-role]').textContent
        let sub = dPopup.querySelector('[data-sub]').textContent

        storageDate = dPopup.querySelector('[data-bd]').textContent

        popup.querySelector('[name="birthday"]').value = storageDate
        // Редактируемые поля
        // popup.querySelector('[name="sur"]').value = name[0]
        // popup.querySelector('[name="first"]').value = name[1]
        // popup.querySelector('[name="middle"]').value = name[2]
        popup.querySelector('[name="name"]').value = name

        popup.querySelector('[name="phone"]').value = phone
        popup.querySelector('[name="email"]').value = mail
        // popup.querySelector('[name="day"]').value = bd[0]
        // popup.querySelector('[name="month"]').value = bd[1]
        // popup.querySelector('[name="year"]').value = bd[2]
        popup.querySelector('[name="birthday"]').onfocus = () => {
            popup.querySelector('[name="birthday"]').setAttribute('type', 'date')
            bd = bd.split('.')
            bd = [...bd].reverse()
            popup.querySelector('[name="birthday"]').value = `${bd[0]}-${bd[1]}-${bd[2]}`

            popup.querySelector('[name="birthday"]').oninput = () => {
                let arr = popup.querySelector('[name="birthday"]').value
                arr = arr.split('-')
                if (parseInt(arr[0]) > 2030) {
                    arr[0] = new Date().getFullYear()
                    popup.querySelector('[name="birthday"]').value = `${arr[0]}-${arr[1]}-${arr[2]}`
                }
            }
        }
        // popup.querySelector('[data-role]').querySelectorAll('.dropdown__list-item-text').forEach(el => {
        //     if (el.textContent === popup.querySelector('[data-role]').querySelector('.dropdown__button-text').textContent) {
        //         el.textContent = role
        //     }
        // })
        // popup.querySelector('[data-role]').querySelector('.dropdown__button-text').textContent = role

        popup.querySelector('[data-sub]').querySelectorAll('.dropdown__list-item-text').forEach(el => {
            if (el.textContent === popup.querySelector('[data-sub]').querySelector('.dropdown__button-text').textContent) {
                el.textContent = sub
            }
        })
        popup.querySelector('[data-sub]').querySelector('.dropdown__button-text').textContent = sub
    }
}

const confirmEditEmployee = () => {

}